import { AbsenceAccountingSalaryConfig, BonusAccountingSalaryConfig, AccountingSalaryConfig } from "../model";

export const absenceAccountingSalaryConfigPropsWithWageType = [
    "vacation",
    "compDay",
    "sick",
    "childSick",
    "sickInKUG",
] as const;

export const bonusAccountingSalaryConfigPropsWithWageType = [
    "night1",
    "night2",
    "sunday",
    "holiday",
    "special",
] as const;

export const accountingSalaryConfigPropsWithWageType = [
    "workHourly",
    "workMonthly",
    "workHourlyDays",
    "workMonthlyDays",
    "absenceHourly",
    "absenceHourlyDays",
    "absenceMonthly",
    "absenceMonthlyDays",
    "bonusTaxFree",
    "bonusTaxed",
    "mealsValue",
    "mealsBreakfast",
    "mealsLunch",
    "mealsDinner",
    "commission",
    "bonusAdvance",
    "payAdvance",
    "salary",
] as const;

export function updateAbsenceWageTypeNumber(
    config: AbsenceAccountingSalaryConfig,
    oldNumber: string,
    newNumber: string
): void {
    const updated: Record<string, string> = {};

    absenceAccountingSalaryConfigPropsWithWageType.forEach((prop) => {
        if (config[prop] === oldNumber) {
            updated[prop] = newNumber;
        }
    });
    Object.assign(config, updated);
}

export function removeAbsenceWageTypeNumber(config: AbsenceAccountingSalaryConfig, wageTypeNumber: string): void {
    updateAbsenceWageTypeNumber(config, wageTypeNumber, "");
}

export function updateBonusWageTypeNumber(
    config: BonusAccountingSalaryConfig,
    oldNumber: string,
    newNumber: string
): void {
    const updated: Record<string, string> = {};

    bonusAccountingSalaryConfigPropsWithWageType.forEach((prop) => {
        if (config[prop] === oldNumber) {
            updated[prop] = newNumber;
        }
    });
    Object.assign(config, updated);
}

export function removeBonusWageTypeNumber(config: BonusAccountingSalaryConfig, wageTypeNumber: string): void {
    updateBonusWageTypeNumber(config, wageTypeNumber, "");
}

export function updateAccountingSalaryConfigWageTypeNumber(
    config: AccountingSalaryConfig,
    oldNumber: string,
    newNumber: string
): void {
    const updated: Record<string, string> = {};

    accountingSalaryConfigPropsWithWageType.forEach((prop) => {
        if (config[prop] === oldNumber) {
            updated[prop] = newNumber;
        }
        // handle bonus and absence configs
        else if (
            config[prop] instanceof AbsenceAccountingSalaryConfig ||
            config[prop] instanceof BonusAccountingSalaryConfig
        ) {
            if (config[prop] instanceof AbsenceAccountingSalaryConfig) {
                updateAbsenceWageTypeNumber(config[prop], oldNumber, newNumber);
            } else if (config[prop] instanceof BonusAccountingSalaryConfig) {
                updateBonusWageTypeNumber(config[prop], oldNumber, newNumber);
            }
        }
    });

    // handle benefits
    if (config.benefits) {
        config.benefits.forEach((benefit) => {
            if (benefit.wageTypeNumber === oldNumber) {
                benefit.wageTypeNumber = newNumber;
            }
        });
    }

    if (config.bonuses) {
        config.bonuses.forEach((bonus) => {
            if (bonus.taxed === oldNumber) {
                bonus.taxed = newNumber;
            }

            if (bonus.taxFree === oldNumber) {
                bonus.taxFree = newNumber;
            }
        });
    }

    Object.assign(config, updated);
}

export function removeAccountingSalaryConfigWageTypeNumber(
    config: AccountingSalaryConfig,
    wageTypeNumber: string
): void {
    updateAccountingSalaryConfigWageTypeNumber(config, wageTypeNumber, "");
}
